module.exports = __webpack_public_path__ + "static/media/item-remove.c67db317.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/item-remove.svg
// module id = 606
// module chunks = 0